import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { BodyMedium, H3, H4, P, Small } from "@/components/ui/typography"
import { useHighlight } from "@chakra-ui/react"
import React from "react"

type PurchaseSuccessProps = {
	onContinue: () => void
	email: string
	title: string
	subtitle: string
	description: string
	loginMessage: {
		text: string
		highlightText: string
	}
	continueText: string
}

export const PurchaseWaiting: React.FC = ({}) => {
	return (
		<div>
			<div className="flex items-center justify-center gap-3">
				<div className="animate-spin rounded-full h-4 w-4 border-2 border-primary border-t-transparent" />
				<P className="font-normal">Waiting for payment confirmation...</P>
			</div>
		</div>
	)
}

export const PurchaseSuccess: React.FC<PurchaseSuccessProps> = ({
	onContinue,
	email,
	title,
	subtitle,
	description,
	loginMessage,
	continueText,
}) => {
	const chunks = useHighlight({
		text: loginMessage.text,
		query: loginMessage.highlightText,
	})
	return (
		<div>
			<div className="flex flex-col gap-1">
				<H3>{title}</H3>
				<H4>{subtitle}</H4>
				<Small className="text-muted-foreground">{description}</Small>
			</div>
			<Card className="p-5 bg-slate-100 mt-4">
				<P className="font-normal">
					{chunks.map(({ text, match }, index) => {
						if (!match) return text
						return (
							<span key={index} className={"font-bold"}>
								{text}
							</span>
						)
					})}
				</P>
				<P className="text-primary">{email}</P>
			</Card>
			<Button className="w-full mt-4" size={"lg"} onClick={onContinue}>
				<BodyMedium className="text-primary-foreground">
					{continueText}
				</BodyMedium>
			</Button>
		</div>
	)
}
